import {
  Button, DatePicker, Flex, Select,
} from 'antd';
import { getExactDate } from 'containers/Reports/utils';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';

const quarterOfYear = require('dayjs/plugin/quarterOfYear');

dayjs.extend(quarterOfYear);

const { RangePicker } = DatePicker;
const { Option } = Select;

const DEFAULT_FILTER_OPTIONS = [
  { key: 'day', label: 'Today' },
  { key: 'week', label: 'This week' },
  { key: 'month', label: 'This month' },
  { key: 'quarter', label: 'This quarter' },
  { key: 'last-week', label: 'Last week' },
  { key: 'last-month', label: 'Last month' },
];
const STYLE_OPTIONS = {
  select: 'select',
  button: 'button',
};
function DateRangeInput({
  value, onChange = () => { },
  filterOptions = DEFAULT_FILTER_OPTIONS,
  variant = STYLE_OPTIONS.select,
  disabledDate,
  loading,
  hasAllTimeOption = false,
  placeholder = 'All',
}) {
  console.log('value', value);
  const emptyValue = useMemo(() => {
    if (!hasAllTimeOption) {
      return { range: [], type: null };
    }
    return { range: [], type: 'all' };
  }, [hasAllTimeOption]);
  const { range = [], type } = value || emptyValue;

  const handleChangeDateRangeOptions = (selectedOption) => {
    let startDate = dayjs().startOf(selectedOption);
    let endDate = dayjs().endOf(selectedOption);

    if (selectedOption === 'all') {
      onChange(emptyValue);
      return;
    }
    if (selectedOption.includes('last')) {
      const tokens = selectedOption.split('-');
      const range = tokens[tokens.length - 1];
      const count = tokens.length > 2 ? tokens[1] : 1;
      startDate = dayjs()[range](dayjs()[range]() - count).startOf(range);
      endDate = dayjs()[range](dayjs()[range]() - 1).endOf(range);
    }
    onChange({ range: [dayjs(getExactDate(startDate)), dayjs(getExactDate(endDate))], type: selectedOption });
  };

  const onChangeDate = (range) => {
    if (range.length === 0) {
      onChange(emptyValue);
      return;
    }
    onChange({ range, type: 'custom' });
  };
  return (
    <div className="flex items-center gap-2">
      {
        variant === STYLE_OPTIONS.select && (
          <Select
            value={type}
            className="min-w-[120px]"
            onChange={handleChangeDateRangeOptions}
            placeholder={placeholder}
          >
            {hasAllTimeOption && <Option value="all" key="all">All time</Option>}
            {filterOptions.map((o) => (
              <Option key={o.key} value={o.key}>{o.label}</Option>
            ))}
          </Select>
        )
      }
      {
        variant === STYLE_OPTIONS.button && (
          <Flex gap={8}>
            {filterOptions.map((option) => (
              <Button
                key={option.key}
                loading={loading && value?.type === option.key}
                variant="outlined"
                color={value?.type === option.key ? 'primary' : 'default'}
                onClick={() => handleChangeDateRangeOptions(option.key)}
                className="!rounded-md !font-medium [&.ant-btn-primary]:!bg-green-600 [&.ant-btn-primary]:!border-green-600 hover:[&.ant-btn-primary]:!bg-green-700 hover:[&.ant-btn-primary]:!border-green-700"
              >
                {option.label}
              </Button>
            ))}
          </Flex>
        )
      }
      <RangePicker
        showToday={false}
        value={range}
        onChange={onChangeDate}
        disabledDate={disabledDate}
      />
      <style>
        {`
          .ant-select-selection-item[title="All time"] {
            color: #9e9e9e;
          }
        `}
      </style>
    </div>
  );
}

export default DateRangeInput;
